import { useState } from "react";
import { Pencil, Check, X } from "lucide-react";

function ContattoItem({ label, value, onSave, testId }) {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState(value || "");
  const start = () => { setV(value || ""); setEdit(true); };
  const save = () => { setEdit(false); if ((v || "").trim() !== (value || "")) onSave((v || "").trim()); };
  return (
    <div className="flex items-center gap-1.5 min-w-0" data-testid={testId}>
      <span className="text-[10px] uppercase tracking-wider font-mono text-slate-500 shrink-0">{label}</span>
      {edit ? (
        <>
          <input autoFocus value={v} onChange={(e) => setV(e.target.value)} data-testid={`${testId}-input`}
            onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEdit(false); }}
            className="h-7 min-w-0 w-44 rounded border border-slate-600 bg-slate-900/60 px-2 text-xs text-slate-100 font-mono outline-none focus:border-amber-500" />
          <button type="button" onClick={save} title="Salva" data-testid={`${testId}-save`} className="p-1 rounded text-emerald-400 hover:bg-emerald-500/10"><Check className="h-3.5 w-3.5" /></button>
          <button type="button" onClick={() => setEdit(false)} title="Annulla" data-testid={`${testId}-cancel`} className="p-1 rounded text-slate-400 hover:bg-slate-800"><X className="h-3.5 w-3.5" /></button>
        </>
      ) : (
        <>
          <span className="text-xs text-slate-200 font-mono truncate" data-testid={`${testId}-value`}>{value || "—"}</span>
          <button type="button" onClick={start} title={`Modifica ${label}`} data-testid={`${testId}-edit`}
            className="p-1 rounded text-slate-500 hover:text-amber-400 hover:bg-amber-500/10 transition-colors"><Pencil className="h-3 w-3" /></button>
        </>
      )}
    </div>
  );
}

// Riga contatti modificabili in linea (scheda cliente/controparte della pratica).
export const ContattiInline = ({ fields, values, onSave, testId }) => (
  <div className="flex flex-wrap gap-x-5 gap-y-1.5 py-2" data-testid={testId} onClick={(e) => e.stopPropagation()}>
    {fields.map((f) => (
      <ContattoItem key={f.key} label={f.label} value={values?.[f.key] || ""} onSave={(v) => onSave(f.key, v)} testId={`${testId}-${f.key}`} />
    ))}
  </div>
);
